module.exports = __webpack_public_path__ + "img/floralia.7686a73e.jpg";